import {
    PickupPoint
} from "../widgets/Delivery/components/PickupPointModal/components/PickupPointList/PickupPointItem/types/PickupPoint.interface.ts";
import { StockItem } from "./StockItem.interface.ts";

export interface DeliveryPoint {
    id: number
    name: string,
    townId: number,
    offers: {
        id: number,
        date: string,
        price: number,
        stock: number
    }[],
    stokItems: StockItem[],
}

export type Address = {
    postcode: string
    city: string,
    townId: number,
    street: string
    streetNumber: string
    apartmentNumber: string
}
export enum DeliveryType {
    shipping = 'transport_company',
    pickup = 'self',
    courier = 'courier'
}

export type AllDeliveryOffersTypes = ShippingOffer | CourierOffer | PickupOffer;

export type DeliveryOffer = {
    id: number,
    courierPrice: number,
    transportCompanyPrice: number,
    postcode: string|null,
    address: string|null,
    branchId: number
    townId: number|null
    townName: string,
    street: string|null,
    house: string|null,
    apartment: string|null,
    latitude: number|null,
    longitude: number|null,
    date: string|null
    price: number,
    point: PickupPoint,
    company: Company
    type: string,
    typeName: string,
    comment: string,
    time: DeliveryTimeSlot[],
    offers: Company[],
}

export type UserAddress = {
    townId: number|null
    point: {
        townId: number
        address: string
    },
}

export interface Company {
    id: number
    name: string
    alias: string
    logo: string
}

export interface ShippingOffer {
    type: DeliveryType.shipping
}

export interface PickupOffer {
    type: DeliveryType.pickup
    point: Required<PickupPoint>

}

export interface CourierOffer {
    type: DeliveryType.courier
    time: DeliveryTimeSlot[]
}

export interface DeliveryTimeSlot {
    from: string;
    to: string;
}

